import { render, staticRenderFns } from "./HelpComponent.vue?vue&type=template&id=2005bffe&scoped=true"
import script from "./HelpComponent.vue?vue&type=script&lang=js"
export * from "./HelpComponent.vue?vue&type=script&lang=js"
import style1 from "./HelpComponent.vue?vue&type=style&index=1&id=2005bffe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2005bffe",
  null
  
)

export default component.exports